import instagramSearchesStore from '@/utils/searches_store/instagram'
import { redirectWithoutNavigationGuardError } from './base'

export default ({ redirect, route }) => {
  if(route.params.date_range) return

  const filters = instagramSearchesStore.read()
  if (filters && filters.selectedDates) {
    redirectWithoutNavigationGuardError(redirect, {
      path: `/instagram/${filters.selectedDates}`,
      query: { ...filters.query }
    })
  }
}